import { Box, Button, Typography } from '@mui/material';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import {
  LaunchDarklyEvaluationReasons,
  ScreenName,
  ScreenTemplate,
  UI_FEATURE_FLAGS,
} from '@/constants';
import useFeatureFlag from '@/components/hooks/useFeatureFlag';
import { usePageAttributes } from './contexts/PageAttributesContext';

interface ModalProps {
  enrollmentURL: string;
  pageType?: string;
  serviceIdForMember?: string;
}

const ChildCareModal = ({ enrollmentURL, pageType, serviceIdForMember }: ModalProps) => {
  const generalAgeRanges = ['0 – 12 months', '1 – 4 years', '4 – 6 years', '6+ years'];

  const { segmentNameSingularLowerCase } = usePageAttributes();

  const daycareDirectoryFirstFlag = useFeatureFlag(
    UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id
  );

  const handleModalButton = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const amplitudeData = {
      asset_type: 'Lightbox',
      CTA: e.currentTarget.textContent,
      screen_name: ScreenName.SEGMENTATION,
      screen_template: ScreenTemplate.SEGMENTATION,
    };

    if (
      daycareDirectoryFirstFlag &&
      daycareDirectoryFirstFlag.reason.kind === LaunchDarklyEvaluationReasons.RULE_MATCH
    ) {
      trackAmplitudeEvent(AmplitudeEvent.testExposure, {
        test_name: UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id,
        test_variant: daycareDirectoryFirstFlag.variationIndex,
        service_id_for_member: serviceIdForMember,
        page_template: pageType,
      });
    }

    trackAmplitudeEvent(AmplitudeEvent.monetateAssetClicked, amplitudeData);
  };

  return (
    <>
      <Typography
        align="center"
        display="block"
        mb={1}
        color="textSecondary"
        variant="body2"
        component="span">
        Let&apos;s find a {segmentNameSingularLowerCase} for you!
      </Typography>
      <Typography
        align="center"
        display="block"
        color="textSecondary"
        variant="h1"
        component="span"
        mb={3}
        letterSpacing="-1px">
        How old is your child?
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          '& a': {
            width: '100%',
          },
        }}>
        {generalAgeRanges.map((age) => (
          <Button
            color="secondary"
            size="large"
            key={age}
            data-testid="age-range-button"
            variant="outlined"
            sx={{
              '& + &': {
                marginTop: 2,
              },
            }}
            fullWidth
            component="a"
            onClick={handleModalButton}
            href={`${enrollmentURL}`}
            rel="nofollow">
            {age}
          </Button>
        ))}
      </Box>
    </>
  );
};

export default ChildCareModal;
